import { SELLER_PORTAL_DOWNGRADE_LIST } from '@/_constants';

export const getListFromStorage = () => {
  try {
    return localStorage.getItem(SELLER_PORTAL_DOWNGRADE_LIST);
  } catch {
    return [];
  }
};
